import React from "react";
import { navigate } from "@reach/router";
import { Box, Flex, Text } from "@theme-ui/components";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { HeroSection } from "../molecules";
import { colors, typography } from "../../styles/theme";
import { Icon } from "../atoms";

const videoUrl =
  "https://www.datocms-assets.com/40521/1715166944-homepagev1_herovideo.mp4";

const IconComponent = ({ iconName, text, desc, customStyles }) => {
  return (
    <Flex
      sx={{
        alignItems: "center",
        ...customStyles,
        "@media (max-width: 1042px)": {
          minWidth: "13.75rem",
        },
      }}
    >
      <Icon
        name={iconName}
        color={colors.white}
        size={48}
        style={{ mt: "0.5rem" }}
      />
      <Flex
        sx={{ flexDirection: "column", ml: "1rem", alignItems: "flex-start" }}
      >
        <Text
          as="h3"
          sx={{
            ...typography.h3,
            color: colors.white,
            mb: "0.5rem",
            textAlign: "start",
          }}
        >
          {text}
        </Text>
        <Text
          sx={{
            ...typography.textMd500,
            color: colors.white,
            textAlign: "start",
          }}
        >
          {desc}
        </Text>
      </Flex>
    </Flex>
  );
};

const CompanyStatistics = () => {
  return (
    <Flex sx={outerContainerStyles}>
      <IconComponent iconName="Building2" text="23,000+" desc="Companies" />
      <IconComponent
        iconName="ScrollText"
        text="2,00,000+"
        desc="Payslips / month"
      />
      <IconComponent iconName="UsersRound" text="23,00,000+" desc="Users" />
    </Flex>
  );
};

const HeroBanner = ({ data }) => {
  const bp = useBreakpointIndex({ defaultIndex: 2 });
  const primaryCTA = (e) => {
    const gcName = bp < 2 ? "gc_2001_003" : "gc_2001_002";
    e.preventDefault();
    window.open(
      `/signup/?gc_name=${gcName}&gc_source=wgc%2F%home%2F&gc_index=0/`,
      "_parent",
      "noopener,noreferrer"
    );
  };
  return (
    <Box mx={["1.03rem", "1.03rem", "2rem", "3.12rem"]}>
      <HeroSection
        variant="media"
        heading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.title }}
            sx={{ p: { m: 0 }, color: colors.white }}
          />
        }
        subHeading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.description }}
            sx={{ p: { m: 0 }, color: colors.white }}
          />
        }
        videoUrl={videoUrl}
        bgColor={colors.primaryMain}
        primaryBtnLabel="Start a greytHR Free Account"
        primaryBtnId="home_start_a_greythr_free_account_in_btn"
        secondaryBtnLabel="Talk to Us!"
        secondaryBtnId="home_talk_to_us_in_btn"
        image={data?.image}
        onPrimaryBtnClick={primaryCTA}
        onSecondaryBtnClick={() => {
          navigate('/demo/?utm_source=%2Fhome');
        }}
      >
        <CompanyStatistics />
      </HeroSection>
    </Box>
  );
};

const { outerContainerStyles } = {
  outerContainerStyles: {
    mt: ["1.5rem", "1.5rem", "2rem", "3rem"],
    mb: ["1.5rem", "1.5rem", "2rem", "4rem"],
    flexWrap: "wrap",
    rowGap: "1.5rem",
    columnGap: ["0.75rem", "0.75rem", "2rem", "4rem"],
    flexDirection: ["column", "column", "row", "row"],
    justifyContent: "center",
    "@media (max-width:599px)": {
      maxWidth: "13.75rem",
      margin: "auto",
      my:"1.5rem"
    },
  },
};

export default HeroBanner;
